module.exports = __webpack_public_path__ + "static/media/target.4afb15a9.svg";